module.exports = __webpack_public_path__ + "media/images/pen_gray-a511a1dc.png";